import type { ReactNode } from 'react';

export const LANDING_FAQ_KEYS = [
  'whatIsBloodVision',
  'booking',
  'serviceable',
  'testsAvailable',
] as const;

export const ALL_FAQ_KEYS = [
  ...LANDING_FAQ_KEYS,
  'sampleReport',
  'parameters',
  'whichTest',
  'collection',
  'bloodDrawn',
  'reports',
  'reportTime',
  'doctor',
  'familyBooking',
  'reschedule',
  'cancel',
  'insurance',
] as const;

type BloodVisionTranslator = {
  (key: string): string;
  rich: (
    key: string,
    values: Record<string, (chunks: ReactNode) => ReactNode>,
  ) => ReactNode;
};

export const getBloodVisionFaqData = (
  t: BloodVisionTranslator,
  keys: readonly (typeof ALL_FAQ_KEYS)[number][],
) =>
  keys.map((key) => ({
    title: t(`faq.${key}.title`),
    description: t.rich(`faq.${key}.description`, {
      br: () => <br />,
      email: (chunks) => <a href="mailto:support@ultrahuman.com">{chunks}</a>,
    }),
  }));
